import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { Disclaimer } from '@app/shared/models/dialog/terms-of-use-dialog-model';
@Injectable({
  providedIn: 'root',
})
export class DisclaimerService extends ApiService {
  private disclaimersFilter = 'disclaimers?$orderby=publishDate desc &$top=1';
  private disclaimersEndpoint = 'socrates/authz/api';

  constructor(public http: HttpClient) {
    super(http);
  }

  public getAllDisclaimerVersions(): Observable<Disclaimer[]> {
    return this.http.get<Disclaimer[]>(this.endpoint(this.disclaimersEndpoint, 'disclaimers'));
  }

  public getLatestDisclaimerVersion(): Observable<Disclaimer> {
    return this.http.get<Disclaimer[]>(this.endpoint(this.disclaimersEndpoint, this.disclaimersFilter)).pipe(
      map((versions: Disclaimer[]) => {
        return versions[0];
      })
    );
  }

  public getLatestDisclaimerVersionDirect(): Observable<Disclaimer> {
    return this.http.get<Disclaimer>(this.directEndpoint('api', 'disclaimer', 'latest')).pipe(
      map((versions: Disclaimer) => {
        return versions;
      })
    );
  }
}
